export const get_payment_extra_url = ({zone_id, group_id, extra_limit, price}:
    object_of<string|number>,
)=>{
    let ids = `zone_id=${zone_id}`;
    if (group_id)
        ids += `&group_id=${group_id}`;
    const qs = `${ids}&extra_limit=${extra_limit}&price=${price}`;
    return `/pricing/checkout?${qs}`;
};
